export default __webpack_public_path__ + "media/images/logo-wt-small-menu-color-whitebg-0310b236.png";